import React, { FC } from 'react'

import { Box } from './Box'

import LockIcon from '../LockIcon'
import { SectionViewComponentProps } from '../PageSection'
import styled from 'styled-components'

interface SubsectionValues {
  heading: string
  text: string
  more: string
  protectedLink?: boolean
}

export const Sections4: FC<SectionViewComponentProps> = ({
  section,
}: SectionViewComponentProps) => {
  const { content, pictureUrl } = section
  if (content) {
    const { heading: mainHeading, text: mainText, subsections } = content
    return (
      <Container>
        <Picture>
          <MainHeading>{mainHeading}</MainHeading>
          <MainText>{mainText}</MainText>
          {pictureUrl ? (
            <img src={pictureUrl} alt="" style={{ maxWidth: '427px' }} />
          ) : null}
        </Picture>
        <Sections>
          {subsections?.map(
            ({ heading, text, more, protectedLink }: SubsectionValues) =>
              heading || text || more ? (
                <Section key={`${heading}_${text}_${more}`}>
                  <Heading>{heading}</Heading>
                  <Text>{text}</Text>
                  {more && (
                    <More>
                      <div>
                        <LockIcon locked={protectedLink} />
                        <a href={more} target="_blank">
                          Learn More
                        </a>
                      </div>
                      <a href={more} target="_blank">
                        <img
                          src={require('assets/images/png/learnMore24.png')}
                          width="24"
                          alt=""
                        />
                      </a>
                    </More>
                  )}
                </Section>
              ) : null,
          )}
        </Sections>
      </Container>
    )
  }
  return <Box>Sections4</Box>
}

const Container = styled.div`
  font-family: 'Poppins_400Regular';
  display: flex;
  flex-direction: row;
  padding: 60px 20px;
  width: 100%;
  box-sizing: border-box;
`

const MainHeading = styled.div`
  font-style: normal;
  font-family: 'Poppins_600SemiBold';
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: -0.005em;
  color: #000000;
  margin-bottom: 20px;
  word-wrap: break-word;
`

const MainText = styled.div`
  font-style: normal;
  font-family: 'Poppins_400Regular';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
  margin-bottom: 20px;
  word-wrap: break-word;
`

const Picture = styled.div``

const Sections = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 20px;
  width: 100%;
`

const Section = styled.div`
  width: calc(50% - 20px);
  margin: 5px 10px;
  border-bottom: 1px solid #000000;
`

const Heading = styled.div`
  font-style: normal;
  font-family: 'SourceSansPro_300Light';
  font-weight: 300;
  font-size: 20px;
  line-height: 24px;
  color: #000000;
  margin-bottom: 15px;
  word-wrap: break-word;
`

const Text = styled.div`
  font-family: 'SourceSansPro_400Regular';
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #000000;
  word-wrap: break-word;
`

const More = styled.div`
  display: flex;
  align-items: center;
  padding: 20px 0;

  div {
    font-style: normal;
    font-family: 'Poppins_600SemiBold';
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    letter-spacing: 0.02em;
    color: #000000;
    word-wrap: break-word;
    a {
      color: inherit;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  img {
    margin-left: 12px;
  }
`
